var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrap2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B5DA3",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.445 19.688V21h-6.672v-1.128l3.24-3.534c.356-.401.636-.748.841-1.04.206-.29.35-.553.431-.785.087-.237.13-.467.13-.69 0-.315-.06-.59-.178-.828a1.3 1.3 0 00-.506-.567c-.223-.142-.494-.212-.813-.212-.37 0-.68.08-.93.24-.25.159-.44.38-.567.662a2.271 2.271 0 00-.191.957h-1.648c0-.579.132-1.107.396-1.586a2.9 2.9 0 011.149-1.148c.501-.287 1.105-.43 1.811-.43.666 0 1.23.11 1.696.334.465.223.818.54 1.06.95.245.41.369.896.369 1.456 0 .31-.05.618-.15.923-.101.306-.245.61-.432.916a7.82 7.82 0 01-.649.91c-.25.3-.526.606-.827.915l-2.153 2.372h4.593z"
  })));
}
SvgTrap2.displayName = 'Trap2';
export default SvgTrap2;